import React from "react";

const SendMail = ({ email, children }) => {
  return <a href={`mailto:${email}`} style={{ textDecoration: 'none', color: 'inherit' }}>{children}</a>;
};
export default SendMail;
